import { ComponentBase } from '../../../../component-base';
import { IMouseDown, IMouseMove, IMouseRelease } from '../../Interfaces';
import { PositionCalculatorService } from '../../position-calculator.service';
import { DrawingsHolderService } from '../../drawings-holder.service';
import { Post, SelectableIntermediatePost, SelectablePicket } from '../../object3D';
import { Injectable } from '@angular/core';
import { IRestriction, RangeRestriction, CollisionRestriction } from './MovePostRestrictions';

declare const THREE: any;

@Injectable()
export class MovePostComponent extends ComponentBase
  implements IMouseDown, IMouseMove, IMouseRelease {
  private selectedPost: SelectableIntermediatePost | SelectablePicket | undefined;
  private clickPoint = new THREE.Vector3();
  private initialPosition = new THREE.Vector3();
  private holding = false;
  private restrictions: IRestriction[];

  constructor(
    private positionCalculator: PositionCalculatorService,
    private drawingsHolder: DrawingsHolderService
  ) {
    super();
    this.drawingsHolder.onSelect.subscribe(object => {
      if (object.length < 2) {
      this.selectedPost = object[0];
      } else {
        this.selectedPost = null;
      }
    });

    const canvasChildren = this.drawingsHolder.canvas.children;

    const filter = obj =>
      obj !== this.selectedPost &&
      (obj instanceof SelectableIntermediatePost || obj instanceof Post);

    this.restrictions = [new RangeRestriction(), new CollisionRestriction(canvasChildren, filter)];
  }

  private hasViolations(post: SelectableIntermediatePost | SelectablePicket, newPosition) {
    return (
      this.restrictions.find(restriction => !restriction.check(post, newPosition, post.edge)) !==
      undefined
    );
  }

  mouseDown(e: MouseEvent): boolean {
    if (this.selectedPost) {
      this.holding = true;
      const point = this.positionCalculator.calculate(e);
      this.clickPoint.copy(point);
      this.initialPosition.copy(this.selectedPost.position);
      return true;
    }
    return false;
  }

  mouseMove(e: MouseEvent): boolean {
    if (this.selectedPost && this.holding) {
      const movedPoint = this.positionCalculator.calculate(e);
      const edge = this.selectedPost.edge;
      const delta = movedPoint.sub(this.clickPoint).projectOnVector(edge.direction);
      const newPosition = this.initialPosition.clone().add(delta);
      if (!this.hasViolations(this.selectedPost, newPosition)) {
        this.selectedPost.position.copy(newPosition);
      }
      return true;
    }
    return false;
  }

  mouseUp(e: MouseEvent): boolean {
    this.holding = false;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/MoveObjectComponent/MovePostComponent.ts